import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  link: null,
  isCreating: false,
  isPolling: false,
  error: null,
}

const reducers = {
  creatingLink: state => {
    state.isCreating = true
    state.error = null
  },

  createLinkSuccess: (state, { payload }) => {
    state.link = payload
    state.isCreating = false
    state.error = null
  },

  createLinkError: (state, { payload }) => {
    state.isCreating = false
    state.error = payload
  },

  updateLinkStatus: (state, { payload }) => {
    state.link = payload
    state.error = null
  },

  clearLink: state => {
    state.link = null
    state.error = null
  },

  setPolling: (state, { payload }) => {
    state.isPolling = payload
  },

  setError: (state, { payload }) => {
    state.error = payload
  },
}

const slice = createSlice({
  initialState,
  name: 'experiencePlayerManager',
  reducers,
})

export const actions = slice.actions
export default slice.reducer
